/* FAQ accordion — INXL World. Single open at a time; clicking the open item
 * closes it. Smooth height via the CSS grid-rows trick (see faq.liquid).
 * Ported from FaqAccordion.tsx. Early-returns when no FAQ on the page.
 */
(function () {
  var root = document.querySelector('[data-faq]');
  if (!root) return;
  root.querySelectorAll('[data-faq-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq__item');
      if (!item) return;
      var willOpen = !item.classList.contains('is-open');
      root.querySelectorAll('.faq__item').forEach(function (i) {
        i.classList.remove('is-open');
        var q = i.querySelector('[data-faq-q]');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
